<template>
	<article
		class="relative p-[8.33%] rounded-t-30xl rounded-b-2.5xl h-full flex flex-col"
		:class="{
			'bg-brand-globus-green': variant === 'green' || variant === 'orange',
			'bg-gradient-gray-2': variant === 'dark',
			'bg-background-primary': variant === 'grey',
			'bg-background-secondary': variant === 'light',
		}"
	>
		<div class="w-full mx-auto">
			<figure v-if="$slots.image" class="relative mb-2 sm:mb-6 rounded-[50%] w-full aspect-square overflow-hidden [&>*]:absolute [&>*]:inset-0 [&>*]:size-full">
				<slot name="image" />
			</figure>
		</div>
		<div
			v-if="$slots.title"
			class="font-semibold text-base mb-0 text-center"
			:class="[variant === 'light' ? 'typo-h3' : 'typo-h4']"
		>
			<slot name="title" />
		</div>
	</article>
</template>

<script setup lang="ts">
	interface Props {
		variant?: string
	}
	defineProps<Props>();
</script>
